import {
  type FileResult,
  getFriendlyFileType,
  mapExtensionToMimeType,
} from '@blaze-shared/uploader';

export function getFileFromUrl(url: string): FileResult | null {
  try {
    const urlObject = new URL(url);

    const filename = urlObject.pathname.split('/').pop() || urlObject.pathname;
    const extension = filename.split('.').pop()?.toLocaleLowerCase();
    const mimetype = mapExtensionToMimeType(extension);
    const type = getFriendlyFileType(filename);

    return {
      filename,
      mimetype,
      type,
      url,
    };
  } catch {
    return null;
  }
}
